<table mat-table [dataSource]="downloadsByCountry()"
    class="cdk-visually-hidden visually-hidden"
    [attr.aria-label]="'research.portal.country.downloads' | translate"
>

    <!-- Country Column -->
    <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef> {{'research.portal.datatable.column.country' | translate}} </th>
        <td mat-cell *matCellDef="let country"> {{country.name}} </td>
    </ng-container>

    <!-- Downloads Column -->
    <ng-container matColumnDef="downloads">
        <th mat-header-cell *matHeaderCellDef> {{'research.portal.datatable.column.download' | translate}} </th>
        <td mat-cell *matCellDef="let country"> {{country.value}} </td>
    </ng-container>

    <!-- Percent Column -->
    <ng-container matColumnDef="percent">
        <th mat-header-cell *matHeaderCellDef>{{'research.portal.datatable.column.percent' | translate}}</th>
        <td mat-cell *matCellDef="let country"> {{(country.value * 10 / this.totalDownloads)  > 1
            ? ((country.value / this.totalDownloads)| percent)
            : ((country.value / this.totalDownloads) | percent : '1.0-2') }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<!-- Use by directive -->
<ng-content></ng-content>
